/**
 * Meta (Facebook) Pixel — set REACT_APP_META_PIXEL_ID in .env / CI (e.g. 123456789012345).
 * @see https://developers.facebook.com/docs/meta-pixel
 */

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID?.trim();

let installStarted = false;

function logSkip(reason) {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.info(`[Meta Pixel] ${reason}`);
  }
}

/**
 * Loads fbevents.js once and calls fbq('init', pixelId). Safe to call multiple times.
 */
export function initFacebookPixel() {
  if (!PIXEL_ID) {
    logSkip('REACT_APP_META_PIXEL_ID not set — pixel disabled.');
    return;
  }
  if (typeof window === 'undefined') return;
  if (installStarted) return;
  installStarted = true;

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', PIXEL_ID);
}

/** SPA route change — fire a PageView for Ads Manager / Events Manager paths. */
export function fbPageView() {
  if (!PIXEL_ID || typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', 'PageView');
}

/**
 * Standard or custom events, e.g. Purchase, InitiateCheckout, ViewContent, Lead.
 * @param {string} event
 * @param {Record<string, unknown>} [params]
 */
export function fbTrack(event, params) {
  if (!PIXEL_ID || typeof window === 'undefined' || !window.fbq) return;
  if (params && Object.keys(params).length > 0) {
    window.fbq('track', event, params);
  } else {
    window.fbq('track', event);
  }
}

export function isMetaPixelEnabled() {
  return Boolean(PIXEL_ID);
}

export { PIXEL_ID };
